import { useQuery } from '@tanstack/react-query';
import { apiWrapper } from '@/apiWrapper';
import { getEndpoints } from '@/endpoints';
import type { Branch } from '@/features/appointments/utils/Branch';

interface GetBranchesParams {
  zipCode?: string;
  name?: string;
  lat?: number;
  lng?: number;
}

const getBranches = async (params: GetBranchesParams): Promise<Branch[]> => {
  const url = getEndpoints().branches;
  const config = {
    method: 'GET',
    params: {
      zipCode: params.zipCode,
      name: params.name,
      lat: params.lat,
      lng: params.lng,
    },
  };

  const response = await apiWrapper<Branch[]>(url, config);
  return response ?? [];
};

export const useBranchesQuery = (params: GetBranchesParams, enabled = true) => {
  const hasCoordinates = params.lat !== undefined && params.lng !== undefined;
  return useQuery({
    queryKey: ['branches', params.zipCode, params.name, params.lat, params.lng],
    queryFn: () => getBranches(params),
    enabled: enabled && (!!params.zipCode || !!params.name || hasCoordinates),
    staleTime: 5 * 60 * 1000,
  });
};
